interface ButtonBorderedProps {
    label?: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    fullWidth?: boolean;
    disabled?: boolean;
}

export default ({ label, onClick, fullWidth, disabled }: ButtonBorderedProps) => {
    return (
        <button
            onClick={onClick}
            type="button"
            disabled={disabled}
            className={`py-1.5 px-4 bg-transparent border ${
                disabled ? ' border-gray-500 text-gray-500' : `border-blue-600 text-blue-600 `
            } transition ease-in duration-200 text-center text-sm font-semibold focus:outline-none rounded-md ${fullWidth ? 'w-full' : ''}`}
        >
            {label}
        </button>
    );
};
